import { InputFormController } from './inputForm.controller';
import template from './inputForm.html';

export const inputFormComponent = {
  name: 'inputComponent',
  restrict: 'E',
  controller: InputFormController,
  controllerAs: 'vm',
  template,
  bindings: {
    inputType: '@',
    model: '=',
    form: '='
  }
};
